import { render } from "./VenueUserGrowth.vue?vue&type=template&id=549857c5&scoped=true"
import script from "./VenueUserGrowth.vue?vue&type=script&lang=js"
export * from "./VenueUserGrowth.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-549857c5"

export default script